import { inject } from '@angular/core';
import { BrowserStorage } from '@common/enums';
import { WINDOW } from '@common/window.provider';

export abstract class AbstractStorage {
  protected readonly window = inject(WINDOW);

  protected readonly prefix = BrowserStorage.Prefix;

  abstract set<T>(key: string, data: T): void;

  abstract get<T>(key: string): T;

  abstract remove(key: string): void;
}
